import { SelectizeSettings } from 'assets/js/SelectizePlugin-InfiniteScroll';

import { Alert, Alerts, AlertMissingDataCheck, AlertNotifyUser } from './Alerts.js';

angular
	.module('logbook')
	.directive('alertBuilder', ['$http', '$timeout', '$q', '$location', 'errorHandler', 'batchRequest', '$rootScope', function($http, $timeout, $q, $location, errorHandler, batchRequest, $rootScope)
	{
		return {
			restrict: 'E',
			template: require('./alert-builder.html'),
			scope: {
				selectedLog: '=',
				config: '=',
				singleEditAlert: '=',
				draftSaveMessage: '@',
				publishSaveMessage: '@',
				navigateHaltMessage: '@'
			},
			
			link: {
				pre: function(scope, element, attributes)
				{
					// Configuration options per section
					scope.sections = {
							draftSaveMessage: scope.draftSaveMessage || 'Saving Alert Draft',
							publishSaveMessage: scope.publishSaveMessage || 'Publishing Alert',
							navigateHaltMessage: scope.navigateHaltMessage || 'You have made changes to this alert and will lose any unsaved changes.' +
								' Are you sure you want to leave?',
						
							name: {
								hidden: attributes.hasOwnProperty('hideName')
							},
							parameters: {
								hidden: attributes.hasOwnProperty('hideParameters')
							},
							notification: {
								hidden: attributes.hasOwnProperty('hideNotification')
							},
							notifyUsers: {
								hidden: attributes.hasOwnProperty('hideNotifyUsers'),
								header: attributes['notifyUsersHeader'],
								description: attributes['notifyUsersDescription'],
								forceClear: attributes.hasOwnProperty('forceStatusClear')
							},
							missingDataCheck: {
								hidden: attributes.hasOwnProperty('hideMissingDataChecks'),
								header: attributes['missingDataCheckHeader'],
								description: attributes['missingDataCheckDescription']
							},
							missingDataCheckNotification: {
								hidden: attributes.hasOwnProperty('hideMissingDataCheckNotification')
							}
						};
					
					Object.assign(scope.sections, scope.config);
					
					scope.generateUniqueId = function () {
						function r() {
							return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
						}
						return r() + r() + '-' + r() + '-' + r() + '-' + r() + '-' + r() + r();
					}
					
					scope.descriptionTransformer = function(section)
					{
						if (!scope.sections[section])
							return [];
						
						var using = scope.sections[section].description;
						if (typeof using === 'string')
						{
							using = using.split(/\\n/g);
						}
						return (Array.isArray(using) ? using.map(function(x) { return x.toString(); }) : []);
					};
					
					/**
					 * @type {{currentParameter: AlertParameter, alert: Alert, originalAlert: Alert|undefined}}
					 */
					scope.model = {
						originalAlert: undefined,
						currentDraft: undefined,
						toDelete: [],
						alert: Alerts.createAlert(scope.selectedLog.id),
						currentParameter: Alerts.createParameter(),
						
						saveAsDraft: false,
						publishing: false,
						publishingComment: '',
						
						
						tagDepth: 1,
						useTagDepth: false,
						
						handlebarItems: [],
						
						saveOptions: {
							noErrorPopup: true
						}
					};
					
					scope.versionMgrShowing = false;
					scope.toggleVersionMgr = function(showing)
					{
						scope.versionMgrShowing = (showing != undefined) ? !!showing : !scope.versionMgrShowing;
					};
					
					scope.cpxManager = {
						
						bound: function(cpxScope)
						{
							cpxScope.addEditCallback(function (alert)
							{
								Alerts.createAlert(scope.selectedLog.id, alert);
								scope.alertSelector.onEdit(alert, true);
								scope.toggleVersionMgr(false);
							});
							
							cpxScope.addOnComplexObjectChangedCallback(function()
							{
								scope.disableVersionMgr = !cpxScope.historyObjsMap.getAll().length;
								if (scope.disableVersionMgr)
									scope.toggleVersionMgr(false);
							});
							
							cpxScope.addOnCloseCallback(function()
							{
								scope.disableVersionMgr = !cpxScope.historyObjsMap.getAll().length;
								scope.toggleVersionMgr(false);
							});
						},
						
						getAlert: function()
						{
							return scope.model.alert;
						}
						
					};
					
					/**
					 * Adds a missing data check to the model's alert
					 * @param {AlertMissingDataCheck|null=} missingDataCheck
					 */
					scope.addMissingDataCheck = function(missingDataCheck)
					{
						if (!(missingDataCheck instanceof AlertMissingDataCheck))
							missingDataCheck = scope.model.alert.addMissingDataCheck(scope.specChangeListener);
						
						var selector = scope.createMissingDataCheckUserSelectorBound(missingDataCheck);
						scope.missingDataCheckUserSelectors[selector.localId] = selector;
					};
					
					/**
					 * Gets the UserSelector Config for the supplied specified missing data check.
					 * If one is not present, it is created.
					 * @param {AlertMissingDataCheck|null} missingDataCheck
					 * @return {*}
					 */
					scope.getMissingDataCheckUserBound = function(missingDataCheck)
					{
						var selectorConfig;
						if (missingDataCheck === undefined)
							return;
						
						var id = (missingDataCheck === null)
							? null
							: missingDataCheck.localId;
						
						selectorConfig = scope.missingDataCheckUserSelectors[id];
						if (selectorConfig)
							return selectorConfig;
						else
						{
							var selector = scope.createMissingDataCheckUserSelectorBound(missingDataCheck);
							
							scope.missingDataCheckUserSelectors[missingDataCheck.localId] = selector;
							return scope.missingDataCheckUserSelectors[missingDataCheck.localId];
						}
					};
					
					/**
					 * Creates a UserSelector Configuration for the supplied missing data check and assigns a localID
					 * to identify the missing data check when IDs are not available.
					 * @param {AlertMissingDataCheck|null} missingDataCheck
					 *
					 * @return {UserSelectorConfig}
					 */
					scope.createMissingDataCheckUserSelectorBound = function(missingDataCheck)
					{
						if (missingDataCheck && !missingDataCheck.localId)
							missingDataCheck.localId = scope.generateUniqueId();
						
						function UserSelectorConfig(missingDataCheck)
						{
							var self = this;
							self.defer = $q.defer();
							self.localId = (missingDataCheck) ? missingDataCheck.localId : null;
							
							self.bound = function (userSelectorScope)
							{
								userSelectorScope
									.addOnUserSelectedListener(function(user)
									{
										scope.setNotifyStatus(user, AlertNotifyUser.type.missingData, AlertNotifyUser.state.always)
											.addMissingDataCheck(missingDataCheck, -1, AlertNotifyUser.state.always);
									})
									.setFilter(function(user)
									{
										return !scope.model.alert.hasNotifyUser(user.id, AlertNotifyUser.type.missingData, missingDataCheck)
									})
									.setButtonInnerHtml('<i class="glyphicon glyphicon-plus"></i><span> Add Users</span>');
								
								userSelectorScope.filterUsers(false);
								self.defer.resolve(userSelectorScope);
							};
							
							self.promise = function()
							{
								return self.defer.promise;
							}
						}
						return new UserSelectorConfig(missingDataCheck);
					};
					
					scope.missingDataCheckUserSelectors = {
						// Create the null generic missing data check user configuration
						null: scope.createMissingDataCheckUserSelectorBound(null)
					};
					
					scope.selectizeTagOptions = new SelectizeSettings('tagValues', 'matches', 'id', 'viewString')
						.addCustom('maxItems', 1)
						.addCustom('dropdownParent', 'body')
						.addCustom('onChange', function(value)
						{
							var selected = this.options[value];
							var current = scope.model.currentParameter.getTagConstraint();
							scope.model.currentParameter.setTagConstraint(selected, current ? current.depth : null);
							scope.validateParameter();
						});
					
					scope.selectizeListOptions = new SelectizeSettings('choiceLists', 'nameLike', 'id', 'name')
						.setWildCard('%')
						.addCustom('maxItems', 1)
						.addCustom('dropdownParent', 'body')
						.addCustom('onChange', function(value)
						{
							var selected = this.options[value];
							scope.model.currentParameter.setListConstraint(selected);
							scope.validateParameter();
						});
					
					scope.tagDepthToggled = function($event)
					{
						var current = scope.model.currentParameter.getTagConstraint();
						if (scope.model.useTagDepth)
						{
							scope.model.currentParameter.setTagConstraint(current ? current.tag : null, scope.model.tagDepth);
						}
						else
						{
							scope.model.currentParameter.setTagConstraint(current ? current.tag : null, null);
						}
					};
					
					scope.tagDepthChanged = function()
					{
						var current = scope.model.currentParameter.getTagConstraint();
						var depthVal = (scope.model.useTagDepth) ? scope.model.tagDepth : null;
						
						scope.model.currentParameter.setTagConstraint(current ? current.tag : null, depthVal);
					};
					
					scope.parameterConstraintChanged = function(/*AlertParameter*/ parameter)
					{
						if (parameter.constraintValueField === '0')
							parameter.clearConstraintValueField();
						else if (parameter.constraintValueField === '1')
							parameter.setTagConstraint(parameter.getTagConstraint());
						else if (parameter.constraintValueField === '2')
							parameter.setListConstraint(parameter.getListConstraint());
						
						var clearInstances = function(instance)
						{
							instance.instance.clear();
						};
						
						scope.selectizeListOptions.instances.forEach(clearInstances);
						scope.selectizeTagOptions.instances.forEach(clearInstances);
						
						scope.validateParameter();
					}
					
					//Items for the alert selector
					scope.alertSelector = {
						
						queryParams: {
							sort: 'created,desc'
						},
						
						filter: function(alert)
						{
							return (alert.template === null && alert.id !== scope.model.alert.id)
						},
						onAdd: function()
						{
							scope.createNewAlert();
						},
						onEdit: function(alert, editVer)
						{
							scope.isEditingAlert = true;
							alert.editDraft = !editVer;
							
							scope.model.alert = alert.copy();
							scope.model.originalAlert = scope.model.alert.copy();
							
							//Freeze original alert for save comparison
							Object.freeze(scope.model.originalAlert);
							scope.toggleEditorMode(true);
							
							return $q.when(scope.getDraftVersion())
								.then(function()
								{
									$(element).find('#input-search-users').val('');
									
									// If either AlertNotifyUsers with Missing Data status or AlertMessages with non empty messages
									// are present, an empty scheduler is created.
									if ((scope.model.alert.missingDataMessage.length ||
										scope.model.alert.getNotifyUsersWithType(AlertNotifyUser.type.missingData, undefined, false).length)
										&& !scope.model.alert.missingDataChecks.length)
										scope.addMissingDataCheck();
									
									scope.model.alert.getMissingDataChecks().forEach(function(check)
									{
										check.setCronSpecChangeListener(scope.specChangeListener)
											.executeChangeListener();
									})
								});
						},
						onBind: function(alertSelectorScope)
						{
							scope.selector = alertSelectorScope;
						}
						
					};
				},
				
				post: function(scope, element, attributes)
				{
					var insideEditor = false;
					var readyForSave = false;
					var alertNameTimeout = undefined;
					
					scope.isEditingAlert = false;
					scope.cronVerificationPending = false;
					
					scope.choiceLists = [];
					scope.tags = [];
					
					scope.cronVerification = {};
					scope.baseUrl = $location.absUrl().split("/#")[0];
					
					scope.isMobile = function()
					{
						return window.innerWidth < 768;
					};
					
					/**
					 * Creates a new alert and toggles the visibility of the buttons
					 */
					scope.createNewAlert = function()
					{
						scope.model.alert = Alerts.createAlert(scope.selectedLog.id);
						
						scope.isEditingAlert = false;
						scope.toggleEditorMode(true);
					};
					
					/**
					 * Toggles the collapse of a DOM element
					 * @param event - Event that triggered the toggle
					 * @param {string, {selector:string, collapsed: boolean}[]} selector - Selector for the collapsable element or array of selectors and collapse booleans
					 * @param {boolean} collapsed - Whether the element should should be collapsed
					 */
					scope.toggleCollapse = function(event, selector, collapsed)
					{
						if (event && typeof event.stopPropagation === 'function')
							event.stopPropagation();
						
						if (Array.isArray(selector))
						{
							selector.forEach(function(collapseObj)
							{
								scope.toggleCollapse(event, collapseObj.selector, collapseObj.collapsed);
							});
							return;
						}
						
						var command = (typeof collapsed === 'boolean')
							? (collapsed) ? 'hide' : 'show'
							: 'toggle';
						
						$(element).find(selector).collapse(command);
					};
					
					/**
					 * Toggles the parameter UI and creates a new parameter
					 * @param {boolean} showParameterUI - Whether the parameter UI should be showing
					 * @param {boolean=} isSaving - Whether to add the parameter to the model's alert when hiding the UI
					 */
					scope.toggleParameterUI = function(showParameterUI, isSaving)
					{
						$('#add-parameter').toggleClass('hidden', showParameterUI);
						scope.toggleCollapse(null, $('#collapse-save-parameter'), !showParameterUI);
						
						if (!showParameterUI && isSaving === true && scope.validateParameter())
						{
							if (scope.model.currentParameter.editingId === undefined)
								scope.model.alert.addParameter(scope.model.currentParameter);
							else
							{
								var index = scope.model.alert.parameters.findIndex(function(param) { return param.editingId === scope.model.currentParameter.editingId });
								
								if (index >= 0)
								{
									scope.model.alert.parameters.splice(index, 1, scope.model.currentParameter);
									scope.model.alert.sortParameters();
									scope.setHandleBarItems();
								}
								else
								{
									delete scope.model.currentParameter.editingId;
									scope.model.alert.addParameter(scope.model.currentParameter);
								}
							}
						}
						
						
						$(element).find('#body-parameters').toggleClass('values-disabled', showParameterUI);
						scope.model.currentParameter = Alerts.createParameter(scope.model.alert.id);
						scope.model.useTagDepth = false;
						scope.model.tagDepth = 1;
					};
					
					/**
					 * Opens the parameter builder with a parameter set to be edited.
					 * @param {AlertParameter} parameter
					 */
					scope.editParameterUI = function(parameter)
					{
						parameter.editingId = moment().valueOf();
						scope.model.currentParameter = Alerts.createParameter(scope.model.alert.id, JSON.parse(JSON.stringify(parameter)));
						$('#add-parameter').toggleClass('hidden', true);
						scope.toggleCollapse(null, $('#collapse-save-parameter'), false);
						
						var constraint;
						var type;
						if ((constraint = parameter.getListConstraint()) !== undefined)
						{
							type = 0;
							scope.model.currentParameter.setListConstraint(constraint);
						}
						else if ((constraint = parameter.getTagConstraint()) !== undefined)
						{
							type = 1;
							scope.model.currentParameter.setTagConstraint(constraint.tag, constraint.depth);
						}
						
						$timeout(function()
						{
							if (type === 0)
							{
								if (!isNaN(parseInt(constraint.id)) && scope.selectizeListOptions.instances.length)
								{
									scope.selectizeListOptions.instances[0].instance.addOption(constraint);
									scope.selectizeListOptions.instances[0].instance.addItem(constraint.id);
								}
							}
							else if (type === 1 && constraint.tag)
							{
								if (!isNaN(parseInt(constraint.tag.id)) && scope.selectizeTagOptions.instances.length)
								{
									scope.selectizeTagOptions.instances[0].instance.addOption(constraint.tag);
									scope.selectizeTagOptions.instances[0].instance.addItem(constraint.tag.id);
								}
								
								if (!isNaN(parseInt(constraint.depth)))
								{
									scope.model.useTagDepth = true;
									scope.model.tagDepth = constraint.depth;
								}
							}
						});
						
						$(element).find('#body-parameters').toggleClass('values-disabled', true);
					};
					
					/**
					 * Sets the new value from a parameter's keyValueField and sorts the model's alert's parameters.
					 * @param {AlertParameter} parameter
					 */
					scope.parameterValueChanged = function(parameter)
					{
						parameter.fromKeyValue(parameter.keyValueField);
						if (!parameter.key)
						{
							parameter.clearConstraintValueField();
						}
						scope.model.alert.sortParameters();
					};
					
					/**
					 * Sets the notify type status of an alert user
					 * @param user - LogUser for the change to apply to
					 * @param {string=} alertType - Status Type to be triggered by this event
					 * @param {string=} alertStatus
					 *
					 * @return {AlertNotifyUser}
					 */
					scope.setNotifyStatus = function(user, alertType, alertStatus)
					{
						return scope.model.alert.setNotifyUserState(user, alertType, alertStatus);
					};
					
					/**
					 * @param logUser
					 * @param {AlertMissingDataCheck=} missingDataCheck
					 * @return {AlertNotifyUser}
					 */
					scope.setMissingDataCheckUser = function(logUser, missingDataCheck)
					{
						return scope.setNotifyStatus(logUser, AlertNotifyUser.type.missingData, AlertNotifyUser.state.always)
							.addMissingDataCheck(missingDataCheck, -1, AlertNotifyUser.state.always);
					};
					
					/**
					 * @param {AlertMissingDataCheck|null=} missingDataCheck
					 * @return {AlertNotifyUser[]}
					 */
					scope.getMissingDataCheckUsers = function(missingDataCheck)
					{
						return (missingDataCheck instanceof AlertMissingDataCheck || missingDataCheck === null)
							? scope.model.alert.getMissingDataCheckUsers(missingDataCheck)
							: scope.model.alert.getNotifyUsersWithType(AlertNotifyUser.type.missingData);
					};
					
					/**
					 * @param logUser
					 * @param {AlertMissingDataCheck} missingDataCheck
					 */
					scope.removeMissingDataCheckUser = function(logUser, missingDataCheck)
					{
						scope.model.alert.getMissingDataCheckUsers(missingDataCheck)
							.forEach(function(alertNotifyUser)
							{
								if (alertNotifyUser.logUser === logUser)
								{
									alertNotifyUser.removeMissingDataCheck(missingDataCheck);
								}
							});
						
						if (missingDataCheck === undefined)
							return;
						
						var id = (missingDataCheck === null) ? null : missingDataCheck.localId;
						scope.missingDataCheckUserSelectors[id].promise().then(function(selectorScope)
						{
							selectorScope.filterUsersFromSearch(false);
						});
					};
					
					/**
					 * Saves the model's alert
					 * @param alert
					 * @param {boolean} updating - Whether the alert is updating an original alert or creating a new alert
					 *
					 * @return {Promise<Alert>}
					 */
					scope.saveAlert = function(alert)
					{
						var url = '/api/alerts';
						alert = alert || scope.model.alert;
						return $http.post(url, alert.getSaveModel(scope.baseUrl), scope.model.saveOptions);
					};
					
					/**
					 * Saves the model alert's parameters
					 * @param alert
					 * @param {boolean=false} useBatch - Whether to use the batch API to resolve the requests
					 * @param {Boolean=true} executeBatch
					 * @return {Promise|{}[]}
					 */
					scope.saveAlertParameters = function(alert, useBatch, executeBatch)
					{
						executeBatch = (typeof executeBatch === 'boolean') ? executeBatch : true;
						useBatch = useBatch || false;
						alert = alert || scope.model.alert;
						
						var requests = alert.parameters.map(function(param)
						{
							return (useBatch)
									? batchRequest.req('POST', '/api/alertParameters', param.getSaveModel(scope.baseUrl))
									: $http.post('/api/alertParameters', param.getSaveModel(scope.baseUrl), scope.model.saveOptions);
						});
						if (useBatch && !executeBatch)
							return requests;
						return (useBatch) ? batchRequest.all(requests, scope.model.saveOptions) : $q.all(requests)
					};
					
					/**
					 * Saves the model alert's status messages
					 * @param alert
					 * @param {boolean=false} useBatch - Whether to use the batch API to resolve the requests
					 * @param {Boolean=true} executeBatch
					 * @return {Promise|{}[]}
					 */
					scope.saveAlertMessages = function(alert, useBatch, executeBatch)
					{
						executeBatch = (typeof executeBatch === 'boolean') ? executeBatch : true;
						useBatch = useBatch || false;
						alert = alert || scope.model.alert;
						var requests = alert.getAlertMessagesSaveModel(scope.baseUrl).map(function(msgObj)
						{
							var id = -1;
							switch(msgObj.status)
							{
								case scope.baseUrl + '/api/alertStatuses/1':
									id = alert.activeId;
									break;
								case scope.baseUrl + '/api/alertStatuses/2':
									id = alert.clearId;
									break;
								case scope.baseUrl + '/api/alertStatuses/3':
									id = alert.missingId;
									break;
							}
							return (useBatch)
									? batchRequest.req('POST', '/api/alertStatusMessages', msgObj)
									: $http.post('/api/alertStatusMessages/', msgObj, scope.model.saveOptions);
						});
						if (useBatch && !executeBatch)
							return requests;
						return (useBatch) ? batchRequest.all(requests, scope.model.saveOptions) : $q.all(requests);
					};
					
					/**
					 * Saves the model alert's alert notify users
					 * @param {Alert} alert
					 * @param {Boolean=false} useBatch
					 * @param {Boolean=true} executeBatch
					 * @return {Promise|{}[]}
					 */
					scope.saveAlertUsers = function(alert, useBatch, executeBatch)
					{
						executeBatch = (typeof executeBatch === 'boolean') ? executeBatch : true;
						useBatch = useBatch || false;
						alert = alert || scope.model.alert;
						
						var requests = alert.getAlertNotifyUsersSaveModel(scope.baseUrl).map(function(model)
						{
							
							return (useBatch)
									? batchRequest.req('POST', '/api/alertNotifyUsers/', model.saveModel)
									: $http.post('/api/alertNotifyUsers/', model.saveModel, scope.model.saveOptions);
						});
						if (useBatch && !executeBatch)
							return requests;
						return (useBatch) ? batchRequest.all(requests, scope.model.saveOptions) : $q.all(requests);
					};
					
					/**
					 * Saves the model alert's alert missing data checks
					 * @param {Alert} alert
					 * @param {Boolean=false} useBatch
					 * @param {Boolean=true} executeBatch
					 * @return {Promise|{}[]}
					 */
					scope.saveAlertMissingDataChecks = function(alert, useBatch, executeBatch)
					{
						executeBatch = (typeof executeBatch === 'boolean') ? executeBatch : true;
						useBatch = useBatch || false;
						alert = alert || scope.model.alert;
						var requests = alert.missingDataChecks.filter(function(check)
						{
							return check.cronSpecVerified;
						})
							.map(function(check)
							{
								return (useBatch)
										? batchRequest.req('POST', '/api/alertMissingDataChecks', check.getSaveModel(scope.baseUrl))
										: $http.post('/api/alertMissingDataChecks', check.getSaveModel(scope.baseUrl), scope.model.saveOptions);
							});
						if (useBatch && !executeBatch)
							return requests;
						return (useBatch) ? batchRequest.all(requests, scope.model.saveOptions) : $q.all(requests);
					};
					
					/**
					 * Saves a provided missing data check and updates the ID of the local object from the result
					 * @param {AlertMissingDataCheck} missingDataCheck
					 */
					scope.saveAlertMissingDataCheck = function(missingDataCheck)
					{
						return $q(function(resolve)
						{
							resolve($http.post('/api/alertMissingDataChecks', missingDataCheck.getSaveModel(scope.baseUrl)));
						})
							.then(function(result)
							{
								missingDataCheck.id = result.data.id;
							});
					};
					
					/**
					 * Sends out pending deletion requests held in the deletion queue
					 * @param {Boolean=false} useBatch
					 * @param {Boolean=true} executeBatch
					 * @return {Promise|{}[]}
					 */
					scope.processDeletions = function(useBatch, executeBatch)
					{
						executeBatch = (typeof executeBatch === 'boolean') ? executeBatch : true;
						useBatch = useBatch || false;
						var requests = scope.model.toDelete.map(function(directUrl)
						{
							return (useBatch)
								? batchRequest.req('DELETE', directUrl)
								: $http.delete(directUrl, scope.model.saveOptions);
						});
						if (useBatch && !executeBatch)
							return requests;
						return (useBatch) ? batchRequest.all(requests, scope.model.saveOptions) : $q.all(requests)
					};
					
					/**
					 * Save all alert properties
					 * @param {Boolean} asDraft
					 * @param {Boolean=true} dismissOnComplete
					 * @return {Promise}
					 */
					scope.saveAll = function(asDraft, dismissOnComplete)
					{
						if (!readyForSave)
							return $q(function(resolve, reject) { reject() });
						
						var alert = scope.model.alert;
						var complexObject = undefined;
						dismissOnComplete = (typeof dismissOnComplete === 'boolean') ? dismissOnComplete : !scope.singleEditMode;
						
						scope.toggleSavingModal(true);
						scope.model.saveAsDraft = asDraft;
						
						// Deletes removed alert messages
						scope.model.toDelete = scope.model.toDelete.concat(alert.getAlertMessagesDeletionModel(scope.baseUrl));
						
						var level = 'ALERT';
						
						var awaitingComment = $q.when(asDraft ? undefined : scope.awaitComment())
							.then(function()
							{
								return scope.verifyDraftPromise();
							});
						if (scope.config && typeof scope.config.preSaveTransformer === 'function')
							scope.config.preSaveTransformer(alert);
						
						return $q.all([$q.when(scope.verificationPromise), awaitingComment])
							.then(function(result)
							{
								// Deletes unverified Missing Data Checks
								for (var i = alert.missingDataChecks.length - 1; i >= 0; i--)
								{
									var missingDataCheck = alert.missingDataChecks[i];
									if (!missingDataCheck.cronSpecVerified)
										scope.deleteMissingDataCheck(missingDataCheck);
								};
								
								return scope.saveAlert(alert);
								
							}, scope.fallback)
							
							.then(function(alertResults)
							{
								console.log('Alert Saved');
								scope.model.alert.setId(alertResults.data.id);
								complexObject = alertResults.data._embedded.complexObject;
								
								if (!isNaN(parseInt(alert.template)))
								{
									level = 'TEMPLATE'
									return $http.patch(complexObject._links.self.href, { forTemplate: '/api/templates/' + alert.template }, {
										noErrorPopup: true
									})
										.catch(function(error)
										{
											// If there is an error while patching the template, query to see if the forTemplate complex object exists
											return $http.get('/api/alertObjects', {
												noErrorPopup: true,
												params: {
													forTemplate: alert.template
												}
											})
												.then(function(results)
												{
													// Update complex object and parameters from existing complex object if it exists
													complexObject = results.data._embedded.alertObjects[0];
													if (complexObject)
													{
														console.log('Updating alert complex object due to template')
														alert.complexObject = complexObject;
														return scope.saveAlert(alert)
															.then(function(alertResults)
															{
																scope.model.alert.setId(alertResults.data.id)
															});
													}
													
													return $q.reject(error);
												})
										})
								}
								
							}, scope.fallback)
							
							.then(function()
							{
								level = 'DATA CHECKS';
								return $q.all(alert.getMissingDataChecks().map(function(dataCheck)
								{
									return scope.saveAlertMissingDataCheck(dataCheck);
								}))
							}, scope.fallback)
							
							.then(function(results)
							{
								var batch = [];
								
								level = 'BATCH';
								return batchRequest.all(Array.prototype.concat(
									batch,
									scope.saveAlertParameters(alert, true, false),
									scope.saveAlertUsers(alert, true, false),
									scope.saveAlertMessages(alert, true, false)
								))
									.then(function()
									{
										var finalizedPatch = {
											saveInProgress: false
										};
										if (!asDraft)
										{
											finalizedPatch.publish = true;
											finalizedPatch.versionNote = (typeof scope.model.publishingComment === 'string')
												? scope.model.publishingComment.slice(0, 250)
												: null;
										}
										return $http.patch(alert.getDirectUrl(scope.baseUrl), finalizedPatch)
									});
								
							}, scope.fallback)
							
							.then(function()
							{
								if (!dismissOnComplete)
									return $q(function(resolve)
									{
										if (scope.singleEditMode)
											scope.isEditingAlert = true;
										
										return $http.get('/api/alerts', {
											params: { id: alert.id }
										})
											.then(function(result)
											{
												return scope.alertSelector.onEdit(Alerts.createAlert(scope.selectedLog.id, result.data._embedded.alerts[0]));
											})
											.then(function()
											{
												scope.toggleSavingModal(false);
											});
									});
								
								return scope.toggleEditorMode(false);
							}, scope.fallback)
							
							.finally(function()
							{
								scope.model.publishingComment = '';
								scope.model.publishing = false;
								if (scope.fallbackError)
								{
									errorHandler.handle('An Error has occurred while saving the alert.', JSON.stringify(scope.fallbackError), true);
								}
								
								scope.toggleSavingModal(false);
								scope.fallbackError = undefined;
								scope.fallbackTriggered = false;
							});
					};
					
					scope.fallback = function(error)
					{
						if (!scope.fallbackTriggered && error)
						{
							console.log('Fallback Triggered');
							scope.fallbackError = error;
						}
						
						scope.fallbackTriggered = true;
						return $q.reject();
					};
					
					/**
					 * Creates a promise that verifies the model's alert is the latest draft
					 * @return {Promise<Boolean>}
					 */
					scope.verifyDraftPromise = function()
					{
						var newDefer = $q.defer();
						$q.when(scope.resolveDraftAwait(false))
							.finally(function()
							{
								scope.model.newerDraft = false;
								$q(function(resolve)
								{
									resolve(scope.getDraftVersion(false)
										.then(function(draft)
										{
											if (draft && !scope.model.currentDraft)
											{
												scope.model.newerDraft = true;
												return;
											}
											scope.model.newerDraft = (draft) ? draft.id !== scope.model.currentDraft.id : false;
											if (!scope.model.newerDraft)
												scope.resolveDraftAwait(true);
										}));
								});
							});
						
						scope.model.awaitDraftDefer = newDefer;
						return scope.model.awaitDraftDefer.promise
							.finally(function()
							{
								scope.model.newerDraft = false;
							});
					};
					
					scope.resolveDraftAwait = function(resolve)
					{
						if (scope.model.awaitDraftDefer)
							scope.model.awaitDraftDefer[((typeof resolve === 'boolean') ? resolve : true) ? 'resolve' : 'reject']();
						
						return $q.when(scope.model.awaitCommentDefer ? scope.model.awaitCommentDefer.promise : undefined);
					};
					
					scope.resolveCommentAwait = function(resolve)
					{
						if (scope.model.awaitCommentDefer)
							scope.model.awaitCommentDefer[((typeof resolve === 'boolean') ? resolve : true) ? 'resolve' : 'reject']();
						
						return $q.when(scope.model.awaitCommentDefer ? scope.model.awaitCommentDefer.promise : undefined)
					};
					
					scope.awaitComment = function()
					{
						$q.when(scope.resolveCommentAwait(false))
							.finally(function()
							{
								scope.model.publishing = true;
								scope.model.awaitCommentDefer.promise
									.finally(function()
									{
										scope.model.publishing = false;
									});
							});
						scope.model.awaitCommentDefer = $q.defer();
						return scope.model.awaitCommentDefer.promise;
					};
					
					scope.clearMissingDataChecks = function()
					{
						scope.model.alert.clearMissingDataChecks();
					};
					
					scope.deleteMissingDataCheck = function(/*AlertMissingDataCheck*/ check)
					{
						scope.model.alert.removeMissingDataCheck(check);
					};
					
					scope.deleteParameter = function(/*AlertParameter*/ parameter)
					{
						scope.model.alert.removeParameter(parameter);
					};
					
					/**
					 * Shows/Hides the editor and create/edit buttons
					 * @param {boolean} showingEditor - Whether the editor should be showing
					 */
					scope.toggleEditorMode = function(showingEditor)
					{
						insideEditor = showingEditor;
						$rootScope.$broadcast('setLazyTabsetConfirm', (showingEditor)
							? function()
							{
								if (scope.model.originalAlert)
									return !scope.model.originalAlert.compare(scope.model.alert);
								return true;
							}
							: false
							, scope.sections.navigateHaltMessage);
						if (!showingEditor)
						{
							$('#collapse-editor').find('.collapse').collapse('hide');
						}
						return $timeout(function ()
						{
							scope.toggleCollapse(null, $('#collapse-editor'), !showingEditor);
							scope.toggleCollapse(null, $('#collapse-create-edit-btns'), showingEditor);
							
							if (!showingEditor)
							{
								scope.toggleParameterUI(false);
								scope.toggleSavingModal(false);
							}
							else
							{
								// Activate the first found tab
								var $selector = $('#collapse-editor .alert-nav > li > a')
									if ($selector.length)
										$selector[0].click();
							}
						})
							.then(function ()
							{
								if (!showingEditor)
								{
									scope.model.alert = Alerts.createAlert(scope.selectedLog.id);
									scope.isEditingAlert = false;
								}
								return $q.when(scope.selector ? scope.selector.searchFromInput() : undefined);
							});
					};
					
					/**
					 * Toggles the saving screen modal
					 * @param {boolean=} showing - Whether the modal should show/hide. Will toggle state if not provided.
					 */
					scope.toggleSavingModal = function(showing)
					{
						var command = (typeof showing === 'boolean')
							? (showing) ? 'show' : 'hide'
							: 'toggle';
						
						$(element).find('#modal-alert-edit').modal(command);
					};
					
					scope.toggleMDCModal = function(localId, showing)
					{
						var command = (typeof showing === 'boolean') ? showing ? 'show' : 'hide' : 'toggle';
						$(element).find('#mdc-setup-' + localId).modal(command);
					};
					
					/**
					 * Gets the header text for an MDC panel built from scheduler and the specified hours and minutes.
					 * @param {AlertMissingDataCheck} dataCheck
					 */
					scope.getMDCHeaderText = function(dataCheck)
					{
						if (!dataCheck.getName()) return 'No Configured Schedule';
						var text = dataCheck.getName();
						if (dataCheck.hours || dataCheck.minutes)
							text = text + ' check for notes within the last '
						if (dataCheck.hours)
							text = text + dataCheck.hours + (dataCheck.hours === 1 ? ' hour ' : ' hours ')
						if (dataCheck.minutes || dataCheck.hours)
							text = text + dataCheck.minutes + (dataCheck.minutes === 1 ? ' minute ' : ' minutes')
						return text;
					}
					
					/**
					 * Validates state of inputs related to the alert.
					 * Includes, alert name
					 */
					scope.validateAlert = function()
					{
						readyForSave = !!scope.model.alert.name;
						var name = scope.model.alert.name.toLowerCase();
						
						$(element).find('#hidden-name-empty').toggleClass('hidden', name.length > 0);
						$(element).find('#hidden-name-taken').toggleClass('hidden', true);
					};
					
					/**
					 * Validates state of inputs related to the currentParameter.
					 */
					scope.validateParameter = function()
					{
						var name = scope.model.currentParameter.name.toLowerCase();
						var index = scope.model.alert.parameters.findIndex(function(parameter)
						{
							var value = parameter.name.toLowerCase() === name;
							
							// Verify the parameter is not the same parameter being edited
							if (parameter.editingId !== undefined || scope.model.currentParameter.editingId !== undefined)
								value = value && parameter.editingId !== scope.model.currentParameter.editingId;
							
							return value;
						});
						
						var invalidKeyConfig = (!!scope.model.currentParameter.key
							&& !(!!scope.model.currentParameter.hasValidListConstraint() || !!scope.model.currentParameter.hasValidTagConstraint()));
						
						$(element).find('#hidden-parameter-empty').toggleClass('hidden', name.length > 0);
						$(element).find('#hidden-parameter-taken').toggleClass('hidden', index < 0);
						$(element).find('#btn-parameter-save').attr('disabled', (index >= 0 || name.length <= 0 || invalidKeyConfig));
						
						return !(index >= 0 || name.length <= 0 || invalidKeyConfig)
					};
					
					scope.alertUserSelectorBound = function(userSelectorScope)
					{
						
						scope.alertUserSelector = userSelectorScope
							.addOnUserSelectedListener(function(user)
							{
								scope.setNotifyStatus(user, AlertNotifyUser.type.clear, (scope.sections.notifyUsers.forceClear)
									? AlertNotifyUser.state.always
									: AlertNotifyUser.state.never);
								
								if (!scope.sections.notifyUsers.forceClear)
									scope.setNotifyStatus(user, AlertNotifyUser.type.active, AlertNotifyUser.state.never);
							})
							.setFilter(function(user)
							{
								return (!scope.sections.notifyUsers.forceClear)
									? !(
										scope.model.alert.hasNotifyUser(user.id, AlertNotifyUser.type.active) ||
										scope.model.alert.hasNotifyUser(user.id, AlertNotifyUser.type.clear)
									)
									: !scope.model.alert.hasNotifyUser(user.id, AlertNotifyUser.type.clear);
							})
							.setButtonInnerHtml('<i class="glyphicon glyphicon-plus"></i><span> Add Users</span>')
					};
					
					/**
					 * CronSpec listener for AlertMissingDataChecks belonging to the alert
					 * @param {AlertMissingDataCheck} dataCheck
					 */
					scope.specChangeListener = function(dataCheck)
					{
						// Verify CronSpec Server Side
						function verifyCron()
						{
							if (dataCheck.hasValidCronObject())
							{
								return $http.get('/api/cronSpecTest', {
									noIndicator: true,
									noErrorPopup: true,
									params: {
										log: scope.selectedLog.id,
										cronSpec: Object.values(dataCheck.cronSpec).join(' '),
										shift: dataCheck.shift.id
									}
								})
									.then(function()
									{
										dataCheck.cronSpecVerified = true;
										dataCheck.clearError();
									}, function(error)
									{
										dataCheck.cronSpecVerified = false;
										dataCheck.setError(error)
									})
									.finally(function()
									{
										scope.cronVerificationPending = false;
									});
							}
							else
							{
								dataCheck.cronSpecVerified = false;
								scope.cronVerificationPending = false;
							}
							
						};
						
						// Sets moment object to identify different schedulers
						if (!dataCheck.verifyId)
						{
							dataCheck.verifyId = scope.generateUniqueId();
						}
						
						if (scope.cronVerification[dataCheck.verifyId])
							$timeout.cancel(scope.cronVerification[dataCheck.verifyId]);
						
						scope.cronVerificationPending = true;
						scope.verificationPromise = scope.cronVerification[dataCheck.verifyId] = $timeout(verifyCron, 600);
					};
					
					/**
					 * Inserts the provided Handle Bar Item's syntax into the text of the element for the selector provided.
					 * @param {HandleBarItem} handlebarItem
					 * @param selector - Selector to be provided to jquery
					 */
					scope.insertHandlebarItem = function(handlebarItem, selector)
					{
						if (!handlebarItem || !handlebarItem.syntax)
							return;
						
						var $selector = $(selector);
						var text = $selector.val();
						var startPosition = $selector.prop('selectionStart');
						var endPosition = $selector.prop('selectionEnd');
						
						if (!$selector.length)
							return;
						
						$selector
							.val(text.slice(0, startPosition) + handlebarItem.syntax + text.slice(endPosition))
							.prop('selectionStart', startPosition + handlebarItem.syntax.length)
							.prop('selectionEnd', startPosition + handlebarItem.syntax.length)
							.trigger('change')
							.focus();
					};
					
					scope.setHandleBarItems = function()
					{
						/**
						 * @param readable
						 * @param description
						 * @param syntax
						 * @constructor
						 */
						function HandleBarItem(readable, description, syntax)
						{
							this.readable = readable;
							this.description = description;
							this.syntax = '{{' + syntax + '}}';
						};
						
						var parameterItems = scope.model.alert.parameters.map(function(param)
						{
							return new HandleBarItem(param.name,
								'This parameter is provided when setting up triggers for this alert',
								'Alert_' + param.name.replace(/[^a-zA-Z0-9]/g, '_'));
						});
						
						var defaultItems = [
							new HandleBarItem('Alert Name', 'The name of this alert', 'AlertName'),
							new HandleBarItem('Alert Status', 'Current status of the alert', 'AlertStatus'),
							new HandleBarItem('Alert Status Update', 'Last time the alert was updated', 'AlertLastUpdate'),
							new HandleBarItem('Alert ID', 'The ID of this alert', 'AlertID'),
							new HandleBarItem('Last Updated By', 'Last user to have updated the note', 'AlertLastUpdateBy'),
							new HandleBarItem('Key Fields', 'Key fields of this alert', 'AlertKeyFields'),
							new HandleBarItem('Note', 'The full note that triggered this alert', 'Note'),
							new HandleBarItem('Template', 'The template name of the note that triggered this alert', 'TemplateName'),
							new HandleBarItem('Note Creation Date', 'Date of creation for the note triggering this alert', 'NoteCreated'),
							new HandleBarItem('Note Edit Date', 'Date of the last update for the note triggering this alert', 'NoteUpdated'),
							new HandleBarItem('Note Time', 'Time of the note that is triggering this alert', 'NoteTime'),
							new HandleBarItem('Carry Forward End Time', 'End time of the carry forward for the note that is triggering this alert', 'NoteCarryForwardEndTime')
						];
						
						return scope.model.handlebarItems =  parameterItems.concat(defaultItems);
					};
					
					scope.getChoiceLists = function()
					{
						var defer = $q.defer();
						$http.get('/api/choiceLists', {
							params: {
								log: scope.selectedLog.id
							}
						})
							.then(function(results)
							{
								defer.resolve(scope.choiceLists = results._embedded.choiceLists);
							}, function()
							{
								defer.resolve([])
							});
						
						return defer.promise;
					};
					
					scope.getReadyForSave = function()
					{
						return readyForSave;
					};
					
					scope.getDraftVersion = function(setCurrentDraft)
					{
						setCurrentDraft = (typeof setCurrentDraft === 'boolean') ? setCurrentDraft : true;
						return $q(function(resolve)
						{
							if (scope.model.alert.complexObject)
							{
								resolve($http.get('/api/alerts', {
									params: {
										'complexObject.id': scope.model.alert.complexObject.id,
										isDraft: true,
										saveInProgress: false,
										sort: 'created,asc',
										size: 1
									}
								}));
							}
							else
							{
								resolve(undefined);
							}
						})
							.then(function(result)
							{
								var draft;
								
								if (result)
									draft = result.data._embedded.alerts[0];
								
								if (setCurrentDraft)
								{
									if (result)
									{
										scope.model.currentDraft = draft;
									}
									else
									{
										scope.model.currentDraft = undefined;
									}
									
									if (scope.model.currentDraft)
									{
										Alerts.createAlert(scope.selectedLog.id, scope.model.currentDraft);
										if (scope.model.alert.editDraft)
										{
											scope.alertSelector.onEdit(scope.model.currentDraft, true);
											console.log('Switching to edit of draft version');
										}
										console.log('Current Draft Set: ' + scope.model.currentDraft.id);
									}
								}
								
								return draft;
							});
					};
					
					scope.$watch('model.alert.name', scope.validateAlert);
					
					scope.$watch('model.alert.subject', scope.validateAlert);
					
					scope.$watch('model.currentParameter.name', scope.validateParameter);
					
					scope.$watch('model.alert.missingDataChecks.length', function()
					{
						scope.model.alert.missingDataChecks.forEach(function(dataCheck)
						{
							if (typeof dataCheck.cronSpecChangeListener !== 'function')
								dataCheck.cronSpecChangeListener = scope.specChangeListener;
						})
					});
					
					scope.$watch('model.alert', function()
					{
						console.log('Set Alert:', scope.model.alert);
						console.log('Clearing Deletion Queue due to alert change.');
						scope.model.toDelete.length = 0;
						scope.cronVerificationPending = false;
						scope.cronVerification = {};
						
						if (scope.alertUserSelector)
							scope.alertUserSelector.filterUsers(false);
					});
					
					scope.$watchCollection('model.alert.parameters', function()
					{
						scope.setHandleBarItems();
					});
					
					scope.$on('helpOpening', function(event, help)
					{
						try {
							var section;
							
							if ($('li.active > a[href="#parameters"]').length)
								section = 'alert-editor-parameters';
							
							else if ($('li.active > a[href="#notification"]').length)
							{
								section = 'alert-editor-notification-messages';
							}
							
							else if ($('li.active > a[href="#users"]').length)
							{
								if (!scope.model.alert.template)
									section = 'alert-editor-users-to-notify';
								else
									section = 'new-note-notifications';
							}
							
							else if ($('li.active > a[href="#mdc"]').length)
							{
								if (!scope.model.alert.template)
									section = 'alert-editor-missing-note-checks';
								else
									section = 'missing-note-notifications';
							}
							
							if (section)
								help.setSection(section, 9);
							
						} catch(e)
						{
							console.error(e);
						}
					});
					
					$q(function(resolve)
					{
						resolve($q.when(typeof scope.singleEditAlert === 'function' ? scope.singleEditAlert() : scope.singleEditAlert))
					})
						.then(function(alert)
						{
							scope.singleEditAlert = alert;
							if (scope.singleEditAlert instanceof Alert)
							{
								scope.alertSelector.onEdit(scope.singleEditAlert)
									.then(function()
									{
										scope.isEditingAlert = scope.singleEditAlert.id > -1;
										scope.singleEditMode = true;
										scope.validateAlert();
									});
							}
						});
						
					
					
					$(element)
						.on('hide.bs.collapse', '#collapse-create-edit-btns,#collapse-editor', function($event)
						{
							if ($event.target.id === 'collapse-create-edit-btns' || $event.target.id === 'collapse-editor')
								$(document).scrollTop(0);
						});
				}
			}
		}
	}]);